import { render, staticRenderFns } from "./UpazilaManage.vue?vue&type=template&id=ebafd160&scoped=true&"
import script from "./UpazilaManage.vue?vue&type=script&lang=js&"
export * from "./UpazilaManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebafd160",
  null
  
)

export default component.exports